var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"dataLoadBtn",class:{
    'swal2-confirm': _vm.canLoadData,
    'swal2-cancel': !_vm.canLoadData,
    'swal2-styled': true,
  },attrs:{"id":"dataLoad","disabled":!_vm.canLoadData},on:{"click":_vm.onLoadData}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }